// extracted by mini-css-extract-plugin
export default {"body":"SettingModal_body__hX09k","save":"SettingModal_save__EIlpn","exit":"SettingModal_exit__u3YrT","disable":"SettingModal_disable__qDasi"};